
import { User } from "@/models";
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
name: "SignUpVerifyCode",
created() {
this.from = this.$route.query.from;
this.phone = this.$route.query.phone;
},
props: [],
data() {
return {
from: "",
code: "",
phone: ""
};
},
methods: {
verifyPhone: function() {
if (this.code == "") {
this.$vux.toast.text("验证码不能为空", "middle");
return;
}

User.signUpOrlogInWithMobilePhone(this.phone, this.code)
.then(() => {
this.$store.commit("logIn", User.current().toJSON());
this.$router.push({
name: "signUpSetInfo",
query: { phone: this.phone, from: this.from }
});
})
.catch(() => {
this.$vux.toast.text("无效的验证码", "middle");
});
}
},
components: {
XInput,
Group,
XButton
}
};



// WEBPACK FOOTER //
// ./src/pages/account/SignUpVerifyPhone.vue